export const STATUSES = {
  PROCESSING: { name: 'PROCESSING', description: 'Processando', badge: 'info' },
  ERROR: { name: 'ERROR', description: 'Erro', badge: 'danger' },
  SUCCESS: { name: 'SUCCESS', description: 'Concluído', badge: 'success' },
  NO_DATA: { name: 'NO_DATA', description: 'Sem dados', badge: 'warning' },
};

export const STATUSES_LIST = [
  STATUSES.PROCESSING,
  STATUSES.ERROR, STATUSES.SUCCESS,
  STATUSES.NO_DATA];

export const REPORT_TYPES = [
  { name: 'PERSONAL_DATA', templateName: 'ficha-registro', description: 'Ficha de Registro do Colaborador' },
  { name: 'VACATION_DUE', templateName: 'expired-vacation', description: 'Férias Vencidas e a Vencer' },
  { name: 'PAYROLL', templateName: 'folha-pagamento', description: 'Folha de Pagamento' },
  { name: 'ADVANCE_PAYROLL_SUMMARY', templateName: 'resumofolha-adt', description: 'Folha de Pagamento de Adiantamento Salarial' },
  { name: 'THIRTEENTH_PAYROLL', templateName: 'folhapagamento-13sal', description: 'Folha de Pagamento do Décimo Terceiro Salário' },
  { name: 'SELF_EMPLOYED_PAYMENT_LIST', templateName: 'SELF_EMPLOYED_PAYMENT_LIST', description: 'Folha de Pagamento a Autônomos' },
  { name: 'PAYROLL_SUMMARY', templateName: 'resumo-folha', description: 'Resumo da Folha Mensal' },
  { name: 'THIRTEENTH_PAYROLL_SUMMARY', templateName: 'resumofolha-13sal', description: 'Resumo do Décimo Terceiro Salário' },
  { name: 'RECEIPT', templateName: 'recibo', description: 'Recibo Mensal' },
  { name: 'RECEIPT_131', templateName: 'recibo-131', description: 'Recibo de Décimo Terceiro - Adiantamento' },
  { name: 'RECEIPT_132', templateName: 'recibo-132', description: 'Recibo de Décimo Terceiro - Integral' },
  { name: 'THIRTEENTH_SALARY_AVERAGES_MAP', templateName: 'decter-mapamedias', description: 'Mapa de Médias do Décimo Terceiro Salário' },
  { name: 'ADVANCE_RECEIPT', templateName: 'recibo-adt', description: 'Recibo de Adiantamento Salarial' },
  { name: 'ADVANCE_INTERN_RECEIPT', templateName: 'recibo-adt-est', description: 'Recibo de Adiantamento de Bolsa Estágio' },
  { name: 'SELF_EMPLOYED_PAYMENT_RECEIPT', templateName: 'SELF_EMPLOYED_PAYMENT_RECEIPT', description: 'Recibo de Pagamento à Autônomo - RPA' },
  { name: 'VACATION_NOTIFICATION', templateName: 'ferias-aviso', description: 'Aviso de Férias' },
  { name: 'VACATION_RECEIPT', templateName: 'recibo-ferias', description: 'Recibo de Férias' },
  { name: 'VACATION_REQUEST_FINANCIAL_ALLOWANCE', templateName: 'ferias-soliabono', description: 'Solicitação de Férias em Abono Pecuniário' },
  { name: 'VACATION_AVERAGES_MAP', templateName: 'ferias-mapamedias', description: 'Mapa de Média nas Férias' },
  { name: 'RESCISSION_RECEIPT', templateName: 'recibo-rescisao', description: 'Termo de Rescisão de Contrato de Trabalho' },
  { name: 'THIRTEENTH_SALARY_AVERAGES_RESCISSION_MAP', templateName: 'decter-mapamedias-rescisao', description: 'Mapa de Médias do Décimo Terceiro Salário na Rescisão' },
  { name: 'VACATION_AVERAGES_RESCISSION_MAP', templateName: 'ferias-mapamedias-rescisao', description: 'Mapa de Médias nas Férias na Rescisão' },
  { name: 'INDEMNIFIED_ADVANCE_NOTICE_AVERAGES_MAP', templateName: 'rescisao-mapamedias', description: 'Mapa de Médias do Aviso Prévio Indenizado' },
  { name: 'COMPETENCE_VACATION_PROVISION', templateName: 'COMPETENCE_VACATION_PROVISION', description: 'Provisão de Férias' },
  { name: 'COMPETENCE_THIRTEENTH_SALARY_PROVISION', templateName: 'COMPETENCE_THIRTEENTH_SALARY_PROVISION', description: 'Provisão de Décimo Terceiro Salário' },
];

export const COLUMN_ORDER_MAPPING = {
  employerName: 'e.nome',
  requestDate: 'request_date',
  backupRequestStatus: 'backup_request_status',
  default: 'request_date',
};

export const NO_REPORTS_SELECTED_ERROR = {
  title: 'Aconteceu um erro',
  description: 'Para realizar a exportação, é necessário selecionar pelo menos um relatório',
  custom: true,
};
